var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.587 0.667969H8.41366C3.56033 0.667969 0.666992 3.5613 0.666992 8.41464V19.5746C0.666992 24.4413 3.56033 27.3346 8.41366 27.3346H19.5737C24.427 27.3346 27.3203 24.4413 27.3203 19.588V8.41464C27.3337 3.5613 24.4403 0.667969 19.587 0.667969ZM9.29366 12.6413C9.68033 12.2546 10.3203 12.2546 10.707 12.6413L13.0003 14.9346V6.6813C13.0003 6.13464 13.4537 5.6813 14.0003 5.6813C14.547 5.6813 15.0003 6.13464 15.0003 6.6813V14.9346L17.2937 12.6413C17.6803 12.2546 18.3203 12.2546 18.707 12.6413C19.0937 13.028 19.0937 13.668 18.707 14.0546L14.707 18.0546C14.6137 18.148 14.507 18.2146 14.387 18.268C14.267 18.3213 14.1337 18.348 14.0003 18.348C13.867 18.348 13.747 18.3213 13.6137 18.268C13.4937 18.2146 13.387 18.148 13.2937 18.0546L9.29366 14.0546C8.90699 13.668 8.90699 13.0413 9.29366 12.6413ZM22.3203 20.9613C19.6403 21.8546 16.827 22.308 14.0003 22.308C11.1737 22.308 8.36033 21.8546 5.68033 20.9613C5.16033 20.788 4.88033 20.2146 5.05366 19.6946C5.22699 19.1746 5.78699 18.8813 6.32033 19.068C11.2803 20.7213 16.7337 20.7213 21.6937 19.068C22.2137 18.8946 22.787 19.1746 22.9603 19.6946C23.1203 20.228 22.8403 20.788 22.3203 20.9613Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSquare);
export default __webpack_public_path__ + "static/media/download-square.b16913624def1b8c9dd676781292a5c6.svg";
export { ForwardRef as ReactComponent };